import { render, staticRenderFns } from "./vatsswap.vue?vue&type=template&id=29c20303&"
import script from "./vatsswap.vue?vue&type=script&lang=ts&"
export * from "./vatsswap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports